import React, { useCallback, useEffect, useState } from 'react';
import Select from 'components/Select';
import FileUploader from 'components/FileUploader';
import AddressTable from 'components/AddressTable';
import Modal from 'components/Modal';
import QrCodeService from '../QrCodeService';
import { uploadFile } from './api/uploadFile';
import {
  getLocationList,
  getByAddressList,
  getRegionList,
} from './api/getLocationList';
import styles from './style.module.scss';

const Npi = () => {
  const [response, setResponse] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [data, setData] = useState([]);
  const [city, setCity] = useState([]);
  const [district, setDistrict] = useState([]);
  const [cityAtsId, setCityAtsId] = useState(null);
  const [districtAtsId, setDistrictAtsId] = useState(null);
  const [npi, setNpi] = useState(null);

  const handleFileSelect = async file => {
    setIsLoading(true);
    try {
      const responseData = await uploadFile(file);
      setData(responseData?.data || []);
      setResponse(responseData);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditModal = itemId => {
    setEditingItem(itemId);
    setIsModalOpen(true);
  };

  const handleEditFullAddress = (id, newAddress) => {
    setData(prevData =>
      prevData.map(item =>
        item.id === id ? { ...item, fullAddress: newAddress } : item,
      ),
    );
    setIsModalOpen(false);
  };

  const handleSelectAddress = (address, postcode) => {
    const region = address.map(item => item.titleRu).join(',');

    const fullAddress = `${postcode[0].id} - ${region}, ${postcode[0].titleRu}`;
    handleEditFullAddress(editingItem, fullAddress);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setEditingItem(null);
  };

  const transformOptionsData = requestData => {
    if (Array.isArray(requestData.data)) {
      return requestData.data.map(item => ({
        label: item.rus.name,
        value: item.atsId,
      }));
    }
    console.error('Data is not an array:', requestData.data);
    return [];
  };

  const transformDistrictsData = requestData => {
    if (Array.isArray(requestData.data)) {
      return requestData.data.map(item => ({
        label: item.rus.name,
        value: item.atsId,
      }));
    }
    console.error('Data is not an array:', requestData.data);
    return [];
  };

  const transformOptionsData2 = requestData => {
    if (Array.isArray(requestData.data)) {
      return requestData.data.map(item => ({
        label: item.addressRus,
        value: item.id,
      }));
    }
    console.error('Data is not an array:', requestData.data);
    return [];
  };

  const handleGetCity = useCallback(async () => {
    const requestData = await getLocationList();
    const formattedOptions = transformOptionsData(requestData.data);
    setCity(formattedOptions);
  }, []);

  const handleGetDistrict = useCallback(async () => {
    if (!cityAtsId) return;
    const requestData = await getRegionList(cityAtsId.value);
    const formattedOptions = transformDistrictsData(requestData.data);
    setDistrict(formattedOptions);
  }, [cityAtsId]);

  const handleGetAddress = useCallback(
    async address => {
      const atsId = districtAtsId ? districtAtsId.value : cityAtsId.value;
      if (!atsId) return [];
      const requestData = await getByAddressList(address, atsId);
      return requestData;
    },
    [cityAtsId, districtAtsId],
  );

  useEffect(() => {
    handleGetCity();
  }, [handleGetCity]);

  useEffect(() => {
    if (cityAtsId) {
      handleGetDistrict();
    }
  }, [cityAtsId, handleGetDistrict]);

  return (
    <>
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <h2>ШПИ / {editingItem}</h2>
        <QrCodeService onSelectAddress={handleSelectAddress} />
      </Modal>
      <div className={styles.npiContainer}>
        <h1 className={styles.headerTitle}>Поиск адреса</h1>

        <Select
          isSearchable={false}
          staticOptions={city}
          placeholder="Город республиканского значения"
          onSelect={setCityAtsId}
        />

        <br />

        {cityAtsId && (
          <Select
            isSearchable={false}
            staticOptions={district}
            placeholder="Введите район"
            onSelect={setDistrictAtsId}
          />
        )}

        <br />

        {(cityAtsId || districtAtsId) && (
          <Select
            asyncRequest={handleGetAddress}
            transformData={transformOptionsData2}
            placeholder="Введите адрес"
            onSelect={setNpi}
          />
        )}

        {npi && (
          <div className={styles.card}>
            <div className={styles.cardHeader}>НПИ: {npi.value}</div>
            <div className={styles.cardContent}>
              <strong>Адрес: </strong>
              {npi.label}
            </div>
          </div>
        )}

        <h1 className={styles.headerTitle}>Загрузите файл с адресами</h1>

        <FileUploader
          onFileSelect={handleFileSelect}
          buttonText="Выберите файл для загрузки"
          acceptedFileTypes=".xlsx, .xls"
        />

        <div className={styles.errorMessage}>
          {response?.data === null && response?.message}
        </div>

        {isLoading && 'Загрузка ...'}
        {data.length > 0 && (
          <AddressTable
            data={data}
            onEdit={handleEditModal}
            onEditFullAddress={handleEditFullAddress}
          />
        )}
      </div>
    </>
  );
};

export default Npi;
